<template>
  <act-list title="今日上新" :search-act-type="1"></act-list>
</template>

<script>

import ActList from "@view/sales/activity/act-list.vue";

export default {
  name: "news",
  components: {ActList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
